import "./styles.css";

const app = document.getElementById("app");

app.innerHTML = `
<h1>Memory leak</h1>
`;

let videos = [];
let imgs = [];

const addVideo = () => {
  let video = document.createElement("video");
  video.src = "";
  app.appendChild(video);
  videos.push(video);
};

const addImg = () => {
  let img = document.createElement("img");
  img.src = "https://i.imgur.com/JajATk0.png";
  app.appendChild(img);
  imgs.push(img);
};

const remove = () => {
  for (let i = 0; i < videos.length; i++) {
    app.removeChild(videos[i]);
    videos[i] = null;
  }
  videos = [];
  for (let i = 0; i < imgs.length; i++) {
    app.removeChild(imgs[i]);
    imgs[i] = null;
  }
  imgs = [];
};

const addVideos = () => {
  for (let i = 0; i < 100; i++) {
    addVideo();
  }
};

const addImgs = () => {
  for (let i = 0; i < 100; i++) {
    addImg();
  }
};
const addVideosClickHandler = e => {
  e.preventDefault();
  addVideos();
};

const addImgsClickHandler = e => {
  e.preventDefault();
  addImgs();
};

const removeClickHandler = e => {
  e.preventDefault();
  remove();
};

const buttonAddVideos = document.createElement("button");
buttonAddVideos.addEventListener("click", addVideosClickHandler);
buttonAddVideos.innerHTML = "Add videos";
app.appendChild(buttonAddVideos);

const buttonAddImgs = document.createElement("button");
buttonAddImgs.addEventListener("click", addImgsClickHandler);
buttonAddImgs.innerHTML = "Add images";
app.appendChild(buttonAddImgs);

const buttonDelete = document.createElement("button");
buttonDelete.addEventListener("click", removeClickHandler);
buttonDelete.innerHTML = "Remove all";
app.appendChild(buttonDelete);
